import { Typography } from "antd"

import styles from "../CreditsAutomationConnectGuide.module.less"

const { Text, Link } = Typography

// `**bold**`, `[[link text]]` (uses linkHref), `{{name}}` (looked up in `variables`, e.g. the
// generated invite email from CHA1-3211 - falls back to the raw token if the value isn't ready yet).
const TOKEN_PATTERN = /\*\*(.+?)\*\*|\[\[(.+?)\]\]|\{\{(\w+)\}\}/g

export const RichText = ({ text, linkHref, variables = {} }) => {
  const parts = []
  let lastIndex = 0
  let match

  while ((match = TOKEN_PATTERN.exec(text))) {
    if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index))

    if (match[1] !== undefined) {
      parts.push(
        <Text className={styles.bold} key={match.index}>
          {match[1]}
        </Text>
      )
    } else if (match[2] !== undefined) {
      parts.push(
        <Link href={linkHref} target="_blank" rel="noopener noreferrer" key={match.index}>
          {match[2]}
        </Link>
      )
    } else {
      parts.push(
        <Text className={styles.bold} key={match.index}>
          {variables[match[3]] ?? `{{${match[3]}}}`}
        </Text>
      )
    }

    lastIndex = TOKEN_PATTERN.lastIndex
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex))

  return <>{parts}</>
}
